export class JoinGroup {
    _id = '';
    max_group = 1;
    is_join_1_group = true;//cho phép tham gia cùng 1 nhóm
    groups = Array();
    content_replys = Array();
    time_before_seeding_from = 2;
    time_before_seeding_to = 5;

    time_after_content_from = 2;
    time_after_content_to = 4;

    time_after_seeding_from = 2;
    time_after_seeding_to = 4;
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_models/auto_seeding/join_group.ts